import { createFileRoute } from "@tanstack/react-router";
import { PageHeader } from "@/components/page-header";
import { UsagePanel } from "@/components/usage-panel";
import { BillingCard } from "@/components/billing-card";
import { Card } from "@/components/ui/card";
import { useMeta } from "@/stores/meta";

export const Route = createFileRoute("/_authed/billing")({
  component: BillingPage,
});

function BillingPage() {
  const meta = useMeta((s) => s.meta);

  // Billing (plans, upgrade, spend cap) is a Deleggate Cloud feature. On a
  // self-hosted instance the billing endpoints aren't even mounted, so guard
  // direct navigation here (the sidebar link is already hidden).
  if (meta && !meta.cloud) {
    return (
      <div className="space-y-6">
        <PageHeader eyebrow="Account" title="Plan & billing" />
        <Card className="p-8 text-center">
          <p className="text-sm font-medium">Billing is a Deleggate Cloud feature.</p>
          <p className="mx-auto mt-1 max-w-md text-sm text-muted-foreground">
            You're running a self-hosted instance — it has no plans or usage limits, so there's
            nothing to bill. Plans and usage live on Deleggate Cloud.
          </p>
        </Card>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <PageHeader eyebrow="Account" title="Plan & billing" />
      <UsagePanel />
      <BillingCard />
    </div>
  );
}
